// Importing the qr package external library
import './qr_packed'